export default __webpack_public_path__ + "static/media/footerEnd.e42bcd85.svg";